import {
  UPDATE_FILE_UPLOAD_PROGRESS,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILED,
  RESET_FILE_UPLOAD_FAILED,
  RESET_FILE_UPLOAD_PROGRESS,
  UPDATE_FILE_INFORMATION_SUCCESS,
  DOWNLOAD_FILE_FAILED
} from './FilesConstants';
import { RESET_PROFILE } from "redux/profiles/ProfilesConstants";

const initialState = {
  loaded: 0,
  total: 0,
  uploading: false,
  completedUpload: false,
  failedUpload: false,
  fileName: '',
  fileExtension: '',
  errorMessage: '',
  failedDownload: false
};

const FilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FILE_UPLOAD_PROGRESS:
      return { ...state, loaded: action.loaded, total: action.total, uploading: true };
    case RESET_FILE_UPLOAD_PROGRESS:
      return { ...state, loaded: 0, total: 0, uploading: false, completedUpload: false };
    case UPLOAD_FILE_SUCCESS:
      return { ...state, uploading: false, completedUpload: true };
    case UPLOAD_FILE_FAILED:
      return { ...state, failedUpload: true, errorMessage: action.errorMessage};
    case DOWNLOAD_FILE_FAILED:
      return { ...state, failedDownload: true, errorMessage: action.errorMessage};
    case RESET_FILE_UPLOAD_FAILED:
      return { ...state, failedUpload: false };
    case UPDATE_FILE_INFORMATION_SUCCESS:
      return { ...state, fileName: action.fileInformation.fileName, fileExtension: action.fileInformation.fileExtension };
    case RESET_PROFILE:
      return { ...initialState };
    default:
      return state;
  }
};

export default FilesReducer;



// WEBPACK FOOTER //
// ./src/redux/files/FilesReducer.js